import * as React from 'react';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

export const FacebookIcon = ({ size = 'xsmall' }: IconProps) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={IconSizes[size]}
            height={IconSizes[size]}
            viewBox="0 0 500 500"
            xmlSpace="preserve"
        >
            <path
                style={{ fill: '#0866ff' }}
                d="M500 250C500 111.929 388.071 0 250 0S0 111.929 0 250c0 117.245 80.715 215.622 189.606 242.638V326.396h-51.552V250h51.552v-32.919c0-85.092 38.509-124.532 122.048-124.532 15.838 0 43.167 3.106 54.347 6.211v69.254c-5.901-.621-16.149-.932-28.882-.932-40.993 0-56.831 15.528-56.831 55.9V250h81.659l-14.029 76.396h-67.63v171.773C404.073 483.218 500 377.818 500 250z"
            />
            <path
                style={{ fill: '#fff' }}
                d="M347.918 326.396 361.946 250h-81.659v-27.018c0-40.372 15.838-55.9 56.831-55.9 12.733 0 22.981.311 28.882.932V98.76c-11.18-3.106-38.509-6.211-54.347-6.211-83.539 0-122.048 39.44-122.048 124.532V250h-51.552v76.396h51.552v166.242A250.51 250.51 0 0 0 250 500c10.253 0 20.358-.632 30.287-1.831V326.396h67.631z"
            />
        </svg>
    );
};
